import React, { useState, useEffect } from "react";
import classes from "./login.module.css";
import Input from "./Input";
import Button from "./button";
import Validation from '../utils/validation'
import Link from "./link";
import axios from "../../Axios";
import { useHistory } from "react-router-dom";
import { notification } from "antd";
const intialState = {
  email: null,
};

const openNotificationWithIcon = (type, message, description) => {
  notification[type]({
    message: `${message}`,
    description: `${description}`,
  });
};
const Reset = ({ setAuth }) => {
  const history = useHistory();
  const [state, setState] = useState({ ...intialState });
  const [loading, setLoading] = useState(false);
  const [isValid, setValid] = useState(false);
   const { email } = state;

   useEffect(() => {
     
     if(Validation().email(email))
      setValid(true);
    else
      setValid(false);
   }, [email])
  const clickHandler = (e) => {
    setLoading(true);
    e.preventDefault();
    axios
      .post("/admin/forgot-password", state)
      .then((res) => {
        setLoading(false);
        const { data } = res;
        if(data.sent)
        {
          
          openNotificationWithIcon(
            "success",
            "Verification Link Sent",
            `A link has been sent to ${state.email}. Click on the link to reset your password`
          );
          history.push('/')
        }
        else{
        
          openNotificationWithIcon(
            "error",
            "Something went wrong",
            `${data.errors[0].message}`
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        openNotificationWithIcon("error", "Something went wrong", `${err}`);
      });
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;

    setState(() => ({ ...state, [name]: value }));
  };
  return (
    <>
      <h1 className={classes.login}>Forgot Password</h1>
      <span className={classes.text}>Please enter your registered email.</span>

      <Input
        onChange={changeHandler}
        name="email"
        value={email?email:''}
        type="email"
        err={null}
        HolderClass={classes.input}
        placeholder="e-mail"
      />

      <Link href="/login" extraClass={classes.link}>
        Login To Your Account
      </Link>

      <Button onClick={clickHandler} extraClass={classes.button} disabled={!isValid} isLoading={loading}>
        Continue
      </Button>
    </>
  );
};

export default Reset;
